// ReporterLabel отдельно (чтобы не тянуть dynamic внутри navbar)

import PulsatingHeart from "./PulsatingHeart";

export function ReporterLabel() {
  return (
    <span className="flex items-center gap-1">
      Я<PulsatingHeart />
      Томск
    </span>
  );
}
